/**
 * Página: Solicitar recuperación de contraseña (pública, sin login)
 * Formulario de un solo campo (email) que dispara el mail de recuperación.
 * Muestra siempre el mismo mensaje genérico que devuelve el backend
 * (ver POST /api/auth/solicitar-recuperacion), exista o no la cuenta — no
 * hay forma de distinguir un email registrado de uno que no lo está.
 * Misma identidad visual que Login.jsx / ActivarCuenta.jsx.
 */

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { STROKE_DEGRADE, IconEmail } from '../components/icons';
import '../styles/login.css';

const API_URL = process.env.REACT_APP_API_URL;

const SolicitarRecuperacion = () => {
  const [email, setEmail] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      setEnviando(true);
      const { data } = await axios.post(`${API_URL}/auth/solicitar-recuperacion`, { email });
      setMensaje(data.mensaje);
      setEnviado(true);
    } catch (err) {
      console.error('Error al solicitar la recuperación:', err);
      setError(err.response?.data?.mensaje || 'Error al procesar el pedido. Intentá de nuevo.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-gradient"></div>

      <div className="login-card">
        <div className="login-logo">
          <img src="/logo-betech.svg" alt="Betech" className="logo-img" />
        </div>

        {!enviado ? (
          <>
            <h1 className="login-title">Recuperar contraseña</h1>
            <p className="login-subtitle">
              Ingresá el email de tu cuenta y te mandamos instrucciones para elegir una nueva contraseña.
            </p>

            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <div className="input-wrapper">
                  <span className="input-icon"><IconEmail size={16} stroke={STROKE_DEGRADE} /></span>
                  <input
                    id="email"
                    type="email"
                    placeholder="tu@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-input"
                    disabled={enviando}
                    required
                  />
                </div>
              </div>

              {error && <div className="error-message">{error}</div>}

              <button type="submit" className="btn-ingresar" disabled={enviando}>
                {enviando ? 'Enviando...' : 'Enviar instrucciones'}
              </button>
            </form>
          </>
        ) : (
          <>
            <h1 className="login-title">Revisá tu email</h1>
            <p className="login-subtitle">{mensaje}</p>
          </>
        )}

        <div className="login-links" style={{ marginTop: 16 }}>
          <Link to="/login" className="link-ayuda">Volver a iniciar sesión</Link>
        </div>

        <div className="login-footer">
          <p>
            © 2026 Betech Solutions |
            <a href="https://be-tech.com.ar" target="_blank" rel="noopener noreferrer">
              {' '}www.be-tech.com.ar
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SolicitarRecuperacion;
